import styled from 'styled-components';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, useParams } from 'react-router-dom';

import { DorikLogo } from './Login/Login';
import { LoginWrap } from './Login/Login.stc';

import graphFetch from '../util/graphFetch';
import { getAuthUser } from '../redux/selectors';

const FormWrap = styled.div`
    width: 400px;
    text-align: center;
    padding: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;

function Verify(props) {
    const user = useSelector(getAuthUser);
    const params = useParams();
    const [message, setMessage] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [isVerified, setIsVerified] = useState(false);

    useEffect(() => {
        (async () => {
            if (user?.isVerified) return;
            setLoading(true);
            const options = {
                queryName: 'verifyAccount',
                select: 'success message',
                args: {
                    token: { type: 'String!', value: params.token },
                },
            };
            const result = await graphFetch(options, true);
            setLoading(false);
            if (!result.data.verifyAccount) {
                setMessage("We couldn't verify your account!");
            } else {
                setTimeout(
                    () => setIsVerified(result.data.verifyAccount.success),
                    3000
                );
                setMessage(result.data.verifyAccount.message);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // mounted

    if (user?.isVerified || isVerified) {
        return <Redirect to="/" />;
    }
    return (
        <LoginWrap>
            <DorikLogo />
            <FormWrap>
                {isLoading && <h3>Verifying...</h3>}
                {message && <h3>{message}</h3>}
                <p>
                    You will be redirected to home page after verificatioin. or{' '}
                    <Link to="/">Click here</Link>
                </p>
            </FormWrap>
        </LoginWrap>
    );
}

export default Verify;
